/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Calendar_TitleInputs */

const en_us2_progress_extra_calendar_title = /** @type {(inputs: Progress_Extra_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This month`)
};

const pt_br2_progress_extra_calendar_title = /** @type {(inputs: Progress_Extra_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendário do mês`)
};

const es_419_progress_extra_calendar_title = /** @type {(inputs: Progress_Extra_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este mes`)
};

const pt_pt2_progress_extra_calendar_title = /** @type {(inputs: Progress_Extra_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este mês`)
};

const fr_fr2_progress_extra_calendar_title = /** @type {(inputs: Progress_Extra_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce mois-ci`)
};

const de_de2_progress_extra_calendar_title = /** @type {(inputs: Progress_Extra_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Monat`)
};

const it_it2_progress_extra_calendar_title = /** @type {(inputs: Progress_Extra_Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo mese`)
};

/**
* | output |
* | --- |
* | "This month" |
*
* @param {Progress_Extra_Calendar_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_calendar_title = /** @type {((inputs?: Progress_Extra_Calendar_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Calendar_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_calendar_title(inputs)
	if (locale === "es-419") return es_419_progress_extra_calendar_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_calendar_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_calendar_title(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_calendar_title(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_calendar_title(inputs)
	return en_us2_progress_extra_calendar_title(inputs)
});
export { progress_extra_calendar_title as "progress-extra.calendar_title" }